import footer from './footer.component';

export default angular
  .module('fizyweb.paycell.noauth.footer', [])
  .component('fizyPaycellNoAuthFooter', footer).name;



// WEBPACK FOOTER //
// src/app/no-auth/components/footer/footer.module.ts